import { Address, ChainConfig, ChainKey, TokenConfig } from "@silo/types";
import { CHAIN_CONFIG } from ".";
import { Option, pipe } from "effect";

export function getChainConfig(chainKey: ChainKey): ChainConfig {
  return CHAIN_CONFIG[chainKey];
}

export function getTokenConfig(
  chainKey: ChainKey,
  tokenAddress: Address
): Option.Option<TokenConfig> {
  return pipe(
    getChainConfig(chainKey),
    (config) => config.tokens[tokenAddress],
    Option.fromNullable
  );
}
